import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shared/components/ui/dialog';
import { Button } from '@/shared/components/ui/button';
import { StatusBadge } from '@/shared/components/ui/status-badge';
import type { UsuarioItem } from '@/shared/api/controllers/usuarios';
import { paisCodeToLabel } from '../../constants';

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  usuario: UsuarioItem | null;
};

export function UsuarioViewDialog({ open, onOpenChange, usuario }: Props) {
  if (!usuario) return null;
  const f = usuario.fields;

  // Compose the full list of permitted países (labels) with the default
  // landing country marked. Falls back to Pais_USR when the permitted
  // array is empty (legacy rows from before multi-region was wired up).
  const permittedLabels = (f.Paises_Permitidos_USR ?? [])
    .map((c) => paisCodeToLabel(c))
    .filter((l): l is 'Argentina' | 'Mexico' => l !== null);
  const labels =
    permittedLabels.length > 0
      ? permittedLabels
      : f.Pais_USR
        ? [f.Pais_USR]
        : [];
  const paisesDisplay = labels.length
    ? labels
        .map((l) => (l === f.Pais_USR && labels.length > 1 ? `${l} (por defecto)` : l))
        .join(', ')
    : '—';

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{f.Nombre_USR || f.UsuarioApp_USR || '—'}</DialogTitle>
          <DialogDescription>Detalle del usuario</DialogDescription>
        </DialogHeader>
        <DialogBody className="text-sm">
          <dl className="grid grid-cols-[8rem_1fr] gap-x-4 gap-y-2">
            <dt className="text-muted-foreground">Usuario</dt>
            <dd>{f.UsuarioApp_USR || '—'}</dd>
            <dt className="text-muted-foreground">Perfil</dt>
            <dd>{f.Perfil_USR || '—'}</dd>
            <dt className="text-muted-foreground">Países</dt>
            <dd>{paisesDisplay}</dd>
            <dt className="text-muted-foreground">Estado</dt>
            <dd>
              <StatusBadge status={f.Status_USR} />
            </dd>
          </dl>
        </DialogBody>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cerrar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
